import { dateRangeDurationLessEqualThan, packValidateResults } from 'helpers/validators';

export const validate = (data: any, translate: any) =>
  packValidateResults([
    dateRangeDurationLessEqualThan(data, ['start_date', 'end_date'], {
      max: 97,
      unit: translate('unit_day'),
    }),
  ]);
